export const domain = {
    name:"DotRoll Kft.",
    address:"1148 Budapest, Fogarasi út 3-5.",
    phone:"+36-1-432-3232",
    link: "www.dotroll.com",
  };